/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'

export default function ContourLegend({ settings, maxCount, opacity = 0.75 }) {
    const colorLegend = scaleLinear()
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain([0, maxCount / 2, maxCount])

    const range = []
    const increments = maxCount / 20
    for (let i = maxCount; i > 0; i -= increments) {
        range.push(i)
    }

    return (
        <g
            id="legend"
            transform={`translate(${settings.vizWidth * 1.08},${
                settings.margin.top
            })`}
        >
            {range.map((d, i) => (
                <g key={`contourLegend_${i}`}>
                    <rect
                        height={15}
                        width={40}
                        x={-24}
                        y={14 + i * 8}
                        stroke="none"
                        fill={colorLegend(d)}
                        opacity={opacity}
                    />
                </g>
            ))}
            <text
                className="legend"
                fill="#f5f5f5"
                textAnchor="middle"
                style={{ fontSize: '1rem' }}
                x={-6}
                y={34}
            >
                {maxCount}
            </text>
            <text
                className="legend"
                fill="#fff"
                textAnchor="middle"
                style={{ fontSize: '1rem' }}
                y={16 + range.length * 8}
            >
                1
            </text>
        </g>
    )
}
